import { MissingComponentWarning } from "core/MissingComponentWarning";
import React from "react";
import { objectPropertiesToArray } from "../utils/utils";
import { ComponentTypeMappings } from "./component-mappings";
import { ComponentTypeWithID, IComponentType, IComponentTypeMapping } from "./ComponentTypeTypes";

export function getComponentModule(type: keyof IComponentTypeMapping) {
  if (!(type in ComponentTypeMappings)) {
    console.warn(`Can't map unknown component type: ${type}`);
    return null;
  }
  return ComponentTypeMappings[type].entryPoint();
}

export function loadComponentModule(type: keyof IComponentTypeMapping) {
  if (!(type in ComponentTypeMappings)) {
    console.warn(`Can't map unknown component type: ${type}`);
    return <MissingComponentWarning componentId={type as string} />;
  }
  return ComponentTypeMappings[type].entryPoint();
}

export function loadEditorModule(type: keyof IComponentTypeMapping) {
  if (!(type in ComponentTypeMappings)) {
    console.warn(`Can't map unknown component type: ${type}`);
    return undefined;
  }
  return ComponentTypeMappings[type].editorEntryPoint;
}

export function getComponentType(type: keyof IComponentTypeMapping): IComponentType | undefined {
  if (!(type in ComponentTypeMappings)) {
    return undefined;
  }

  return ComponentTypeMappings[type];
}

export function getDashboardComponentTypes(): ComponentTypeWithID[] {
  return objectPropertiesToArray(ComponentTypeMappings).filter(
    type => type.dashboardComponent
  ) as ComponentTypeWithID[];
}
